namespace TabAurous.ProductDevelopment {
    export namespace CustomerRequirementSelectItemsService {
        export const baseUrl = 'ProductDevelopment/CustomerRequirementSelectItems';

        export declare function List(request: TransactionRequest, onSuccess?: (response: Serenity.ListResponse<CustomerRequirementItemsRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ProductDevelopment/CustomerRequirementSelectItems/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>CustomerRequirementSelectItemsService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
